import IntlMessages from 'components/Message/IntlMessages';
import styled from 'styled-components';

const BondConnectPDPATitle = ({ onCancel }) => {
  return (
    <BondConnectPDPATitleStyled className="kt-font-ex-b color-primary-navy-blue">
      <div><IntlMessages id="bond-connect.pdpa.title.line1" /></div>
      <div><IntlMessages id="bond-connect.pdpa.title.line2" /></div>
      <CloseButtonStyled className="feather-icon icon-x" onClick={onCancel}></CloseButtonStyled>{" "}
    </BondConnectPDPATitleStyled>
  )
}

const BondConnectPDPATitleStyled = styled.div`
  padding: 16px 0px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const CloseButtonStyled = styled.i`
  position: absolute;
  top: 22px;
  right: 18px;
  cursor: pointer;
  font-size: 22px;
`;

export default BondConnectPDPATitle;